import {Component, DestroyRef, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {GetAllCampaignGroupPayloadModel} from '../campaign-groups/campaign_groups_interfaces';
import {CreateCampaignGroupInitPayload} from '../campaign-groups/campaign-groups.component';
import {Subject, takeUntil} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CurrentCrudSelectBehaviorServiceAsString, SnackBarService} from '../objectPassingService';
import {Router} from '@angular/router';
import {CampaignGroupsService} from '../campaign-groups/campaign-groups.service';
import {GetAllAdgroupPayloadModel} from '../adgroups/adgroup_interfaces';
import {environment} from '../../environments/environment';
import {CreateAdgroupInitPayload} from '../adgroups/adgroups.component';
import {MatButton} from '@angular/material/button';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatProgressBar} from '@angular/material/progress-bar';

import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MatSlideToggle} from "@angular/material/slide-toggle";

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOption, MatSelect, MatSelectModule} from '@angular/material/select';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';

function isCreateCampaignGroupInitPayload(obj: any): obj is CreateCampaignGroupInitPayload {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.is_edit === false &&
    Object.keys(obj).length === 1
  );
}

function isGetAllCampaignGroupPayloadModel(obj: any): obj is GetAllCampaignGroupPayloadModel {
  /*
  The reason we kept both isCreateAdInitPayload() and isGetAllAdPayloadModel() was:
	•	To future-proof (in case is_edit accidentally shows up in GetAllAdPayloadModel)
	•	To keep the checks isolated and testable
	•	To avoid assumptions in the “else” branch
   */
  return obj && typeof obj === 'object' && typeof obj.name === 'string';
}


@Component({
  selector: 'app-campaign-groups-meta',
  imports: [
    MatButton,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatProgressBar,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
    MatSlideToggle,
    MatFormFieldModule,
    MatSelect,
    MatOption,
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardHeader,
    MatSelectModule,
    MatFormFieldModule,
    MatTooltipModule
],
  standalone: true,
  templateUrl: './campaign-groups-meta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaign-groups-meta.component.css'
})
export class CampaignGroupsMetaComponent implements OnInit, OnDestroy {

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_edit = false;
  is_form_error: boolean = false;
  form_error_message: string = "";
  myForm!: FormGroup;
  title_text = "Create Adgroup";
  submit_text = "Create"




  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  campaign_id: string = '';
  is_loading = true;

  campaign_group_list: GetAllCampaignGroupPayloadModel[] | undefined

  campaign_group_select_list = [
    {'id': "root", 'name': 'Root'},
  ]

  hoursOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    public router: Router, //all components need this
    private currentCrudSelectBehaviorService: CurrentCrudSelectBehaviorServiceAsString,
    private campaignGroupsService: CampaignGroupsService,
  ) {
  } // end constructor


  ngOnInit(): void {

    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_sequence_id = localStorage.getItem('campaign_group_sequence_id') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';

    // Use localStorage data on reload
    const savedCampaignGroupMeta = localStorage.getItem('campaigngroupsaved');


    const campaign_group_list_temp = localStorage.getItem('campaign_group_list');
    if ( campaign_group_list_temp) {
      this.campaign_group_list = JSON.parse(campaign_group_list_temp);

      if (this.campaign_group_list){
        for (const obj of this.campaign_group_list) {
          this.campaign_group_select_list.push({ id: obj.campaign_group_id, name: obj.name });
        }

      }





      // this.campaign_group_list.forEach((obj: GetAllCampaignGroupPayloadModel) => {
      //   this.campaign_group_select_list.push({ id: obj.campaign_group_id, name: obj.name });
      // });

    }

    if (savedCampaignGroupMeta) {
      // now if I want I can ... if exists go back to ads rather than having
      // to deal with updating saved storage e.g. on input update saved storage
      // will keep on for development for now
      //this.backToAds()

      if (environment.environment == 'production') {
        this.backToCampaignGroups()
      }

      try {
        const parsed = JSON.parse(savedCampaignGroupMeta);
        if (isCreateCampaignGroupInitPayload(parsed)) {
          const obj: CreateAdgroupInitPayload = parsed;
          console.log('[Reload] Editing state:', obj);
          this.setForm(); // Or pass in data if needed
          this.is_edit = obj.is_edit;
        } else if (isGetAllCampaignGroupPayloadModel(parsed)) {
          const obj: GetAllCampaignGroupPayloadModel = parsed;
          console.log('[Reload] Ad Data:', obj);
          this.setForm(obj);
          this.is_edit = true;
          this.campaign_group_id = obj.campaign_group_id;
        }
      } catch (e) {
        console.error('Error parsing localStorage adsaved:', e);
      }
    } // end if savedAdMeta

    // Subscriptions from services (live interaction)
    this.currentCrudSelectBehaviorService.current$.pipe(takeUntil(this.destroyed)).subscribe(x => {
      if (!x) return;

      try {
        const parsed = JSON.parse(x);

        if (isCreateCampaignGroupInitPayload(parsed)) {
          console.log('[Stream] Create Payload:', parsed);
          this.setForm();
          this.is_edit = parsed.is_edit;
        } else if (isGetAllCampaignGroupPayloadModel(parsed)) {
          console.log('[Stream] Edit Payload:', parsed);
          this.setForm(parsed);
          this.is_edit = true;
        } else {
          throw new Error('Unknown payload structure');
        }

        localStorage.setItem('campaigngroupsaved', JSON.stringify(parsed));
      } catch (e) {
        console.error('Error parsing stream payload:', e);
      }
    }); // end subscription





  } // end ngOnInit


  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } // end ngOnDestroy

  setForm(data?: GetAllCampaignGroupPayloadModel) {

    if (!data) {

      this.myForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        status: new FormControl(false, [Validators.required]),
        campaign_group_parent_id: new FormControl('', [Validators.required]),
        campaign_type: new FormControl('branding', [Validators.required]),
      });

    } else {
      this.submit_text = "Edit"

      let is_status =false;
      if (data.status == "active") {
        is_status = true;
      } else {
        is_status = false;
      }

      this.myForm = this.fb.group({
        name: [data.name],
        status: [is_status],
        campaign_group_parent_id: [data.campaign_group_parent_id],
        campaign_type: [data.campaign_type]
      });
    }

    this.is_loading = false
  } // setForm

  backToCampaignGroups() {
    localStorage.removeItem('campaigngroupsaved')
    //this.router.navigate(['/nav-campaigns', {outlets: {admeta: ['ads']}}]);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['campaign-groups'] } }]).then(r => console.log('redirect to campaign-groups'));
  } // end backCampaignGroups

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = "";
  } // end onFocus

  onSubmit(){

    this.is_loading = true;
    let form_data = this.myForm.value;
    form_data['client_id'] =  this.client_id  //Math.floor(parseInt(form_data['client_id'], 10));
    console.log(form_data)

    let status = 'paused';
    if (form_data['status'] == true) {
      status = 'active';
    } else {
      status = 'paused';
    }
    form_data['status'] = status;

    if (!this.is_edit) {

      this.campaignGroupsService.post(`adserver/campaign_group/create/${this.client_id}/${this.campaign_group_sequence_id}`, form_data).pipe(takeUntil(this.destroyed)).subscribe(x => {
        this.snackBarService.announceSackBar('Campaign Group Created');
        this.is_loading = false;
        this.backToCampaignGroups();
      }, error => {
        console.log('error',error)

      });

    } else {
      let endpoint = `adserver/campaign_group/${this.campaign_group_id}`;
      console.log('endpoint',endpoint)
      this.campaignGroupsService.put(endpoint, form_data).subscribe(x => {
        this.snackBarService.announceSackBar('Campaign Group Updated');
        this.is_loading = false;
      }, error => {
        this.is_loading = false;
        this.snackBarService.announceSackBar('Campaign Group Update Error');
        console.log('error',error)

      });
    } //end if

  } // end OnSubmit

} // End of CampaignGroupsMetaComponent
